import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapPin, Globe } from "lucide-react";
import { api, imgUrl } from "../lib/api";
import { SEO } from "../components/SEO";
import { MagazineCard } from "../components/site/MagazineCard";
import { NotFound } from "../components/site/NotFound";
import { SafeImg } from "../components/site/SafeImg";

export default function PublisherDetailPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setData(null); setNotFound(false);
    api.get(`/publishers/${slug}`).then((d) => (d && d.publisher ? setData(d) : setNotFound(true))).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <NotFound title="Publisher not found" message="This publishing house isn't on BookMala (yet)." testId="publisher-not-found" />;
  if (!data) return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 animate-pulse" data-testid="publisher-loading">
      <div className="flex items-center gap-8"><div className="w-28 h-28 bg-bm-sand/60 rounded-xl" /><div className="flex-1 space-y-3"><div className="h-10 bg-bm-sand/60 rounded w-1/2" /><div className="h-4 bg-bm-sand/60 rounded w-2/3" /></div></div>
    </div>
  );
  const { publisher: p, magazines } = data;
  return (
    <div data-testid="publisher-detail-page">
      <SEO title={p.name} description={p.about} image={p.logo} path={`/publishers/${slug}`} />
      <div className="bg-bm-ink py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex flex-col sm:flex-row items-center gap-8">
          <SafeImg src={imgUrl(p.logo)} alt={p.name} className="w-28 h-28 rounded-xl object-cover shadow-cover-hover" />
          <div>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-white" data-testid="publisher-name">{p.name}</h1>
            <p className="text-[#D1D1D1] mt-3 max-w-2xl leading-relaxed">{p.about}</p>
            <div className="flex flex-wrap gap-5 mt-4 text-sm text-[#B0B0B0]">
              {p.founded_year && <span>Est. {p.founded_year}</span>}
              {p.address && <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4" /> {p.address}</span>}
              {p.website && <a href={p.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-bm-sand transition-colors duration-200" data-testid="publisher-website"><Globe className="w-4 h-4" /> Website</a>}
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 md:py-20">
        <span className="eyebrow">The Catalog</span>
        <h2 className="font-display text-3xl md:text-4xl font-semibold mt-3 mb-10 text-bm-ink">Magazines from {p.name}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {magazines.map((m) => <MagazineCard key={m.id} mag={m} showPublisher={false} />)}
        </div>
      </div>
    </div>
  );
}
